import React from 'react';
import './EnterpriseFeaturesSection.css';

const FEATURES = [
  { title: 'Feature 1', body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
  { title: 'Feature 2', body: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' },
  { title: 'Feature 3', body: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.' },
  { title: 'Feature 4', body: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum.' },
  { title: 'Feature 5', body: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa.' },
  { title: 'Feature 6', body: 'Curabitur pretium tincidunt lacus. Nulla gravida orci a odio.' },
];

export default function EnterpriseFeaturesSection() {
  return (
    <section className="enterprise">
      <div className="enterprise-header">
        <h2>Placeholder</h2>
        <p>Placeholder lorem ipsum dolor sit amet.</p>
      </div>

      <div className="enterprise-grid">
        {FEATURES.map((feature, idx) => (
          <div key={idx} className="enterprise-card">
            <div className="enterprise-icon" />
            <h3>{feature.title}</h3>
            <p>{feature.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
